import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEditry } from '@lazylabs-dev/editry-react';

function Login() {
  const navigate = useNavigate();
  const { loginAdmin, setOverlayEnabled } = useEditry();
  const [identity, setIdentity] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!identity.trim() || !password) {
      setError('Vyplň email/username a heslo.');
      return;
    }

    setLoading(true);
    try {
      const payload = identity.includes('@')
        ? { email: identity.trim(), password }
        : { username: identity.trim(), password };

      await loginAdmin(payload);
      setOverlayEnabled(false);
      navigate('/');
    } catch (submitError) {
      setError(submitError instanceof Error ? submitError.message : 'Přihlášení selhalo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="text-center scrollto clearfix" style={{ minHeight: '40vh', paddingTop: '120px' }}>
      <div className="row clearfix">
        <h2 className="section-title white-title">Admin Login</h2>
        <form
          onSubmit={handleSubmit}
          style={{
            maxWidth: '420px',
            margin: '24px auto 0',
            display: 'grid',
            gap: '12px',
            textAlign: 'left'
          }}
        >
          <label className="barlow-medium" style={{ display: 'grid', gap: '6px' }}>
            Email nebo username
            <input
              value={identity}
              onChange={(event) => setIdentity(event.target.value)}
              autoComplete="username"
              style={{ height: '44px', padding: '0 12px', border: '1px solid #d3d7e1', borderRadius: '999px' }}
            />
          </label>

          <label className="barlow-medium" style={{ display: 'grid', gap: '6px' }}>
            Heslo
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              style={{ height: '44px', padding: '0 12px', border: '1px solid #d3d7e1', borderRadius: '999px' }}
            />
          </label>

          {error ? (
            <p role="alert" style={{ margin: 0, color: '#b42318', fontWeight: 600 }}>{error}</p>
          ) : null}

          <button
            type="submit"
            disabled={loading}
            style={{
              height: '46px',
              borderRadius: '999px',
              border: '1px solid #111',
              background: '#111',
              color: '#fff',
              fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Přihlašuji…' : 'Přihlásit'}
          </button>
        </form>
      </div>
    </section>
  );
}

export default Login;
